const getCountries = () => {
    return ApiClient.get('/countries');
};

export { getCountries };
